import React, { Component } from "react";
import posed from "react-pose";
import styled from "styled-components";
import { tween } from "popmotion";
import { Link } from "react-router-dom";
import copyToClipboard from "../../modules/utils/copyToClipboard";

// import "./index.css";

const config = {
  fullscreen: {
    width: "100vw",
    height: "100vh",
    transition: tween,
    flip: true
  },
  thumbnail: {
    width: 272,
    height: 230,
    transition: tween,
    flip: true
  }
};

const AttentionAnimated = posed.div({
  attention: {
    scale: 1.3,
    transition: {
      type: "spring",
      stiffness: 5,
      damping: 0
    }
  },
  idle: {
    scale: 1
  }
});

const SpringAnimated = posed.div({
  idle: { scale: 1 },
  hovered: { scale: 1.5 }
});

const PopupAnimated = posed.div(config);
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

const StyledSquare = styled(PopupAnimated)`
  background: #ff000000;
  //   background: red;
`;

class ShowView extends Component {
  state = {
    showContent: false,
    active: false,
    hovering: false,
    attention: false,
    isMailOver: false
  };

  componentDidMount() {
    this.setState({ attention: true });
  }

  onClick = () => {
    this.setState(
      {
        active: !this.state.active,
        showContent: !this.state.active
      },
      () => {
        if (this.state.active) {
          this.setState({ attention: false });
        }

        // setTimeout(() => {
        //   console.log("showContent", this.state.active);
        //   this.setState({ showContent: this.state.active });
        // }, 2000);
      }
    );
  };

  onHover = hovering => {
    this.setState({ hovering });
  };

  render() {
    return (
      <Container>
        <ShareComponent />
        <StyledSquare
          className="box"
          onClick={this.onClick}
          pose={!this.state.active ? "thumbnail" : "fullscreen"}
        >
          {this.state.showContent ? (
            <ContentLayout>{this.props.children}</ContentLayout>
          ) : (
            <SpringAnimated
              onMouseEnter={() => this.onHover(true)}
              onMouseLeave={() => this.onHover(false)}
              pose={this.state.hovering ? "hovered" : "idle"}
            >
              <React.Fragment>
                {!this.state.hovering && (
                  <MailImageClose
                    src="../../images/close_mail.png"
                    alt="close mail"
                    onHover={() => {
                      this.setState({ hovering: true });
                    }}
                  />
                )}
                {this.state.hovering && (
                  <MailImageOpen
                    src="../../images/open_mail.png"
                    alt="open mail"
                  />
                )}
              </React.Fragment>
            </SpringAnimated>
          )}
        </StyledSquare>
      </Container>
    );
  }
}

export default ShowView;

const ShareComponent = () => {
  const currentLink = window.location.href.replace("posts/", "?post=");
  return (
    <ShareComponentStyle className="">
      <div className="right-align">
        {/* <input type="text" name="sendURL" defaultValue={currentLink} disabled /> */}
        <div
          className="btn"
          onClick={() => {
            copyToClipboard(currentLink);
            window.M.toast({
              html: `copy ${currentLink} success!!`
            });
          }}
        >
          <span>Copy Link</span>
        </div>
        <Link className="btn light-blue lighten-5 black-text" to="/">
          + New Post
        </Link>
      </div>
    </ShareComponentStyle>
  );
};

const ShareComponentStyle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
  z-index: 9999;
`;

const MailImageOpen = styled.img`
  max-width: 272px;
`;

const MailImageClose = styled.img`
  max-width: 272px;
`;

const ContentLayout = styled.div`
  background: #fff0e44a;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/templates/show-post/ShowView.js